module.exports = __webpack_public_path__ + "media/images/covid/mainImg-2eee13d4e04cf76ab2624841b97d95d8.jpg";